import React, { useState, useEffect } from 'react';
import DocumentStoreService from '@services/documentStore/DocumentStoreService';
import useServiceHook from '@hooks/useServiceHook';
import InfoModalContainer from '@components/modal/Container';
import Button from '@components/buttons/Button/Button';
import CircularSpinner from "@components/spinners/Circular/Circular";
import { PanelItem } from '@components/panels/PanelItems';

const LoadingSpinner = () => (
    <div data-testid="loading-spinner" style={{ display: 'flex', justifyContent: 'center', margin: '15vh' }}>
        {<CircularSpinner />}
    </div>
)

export type DocumentStoreFileDetailProps = {
    documentStoreRecordId: number,
    s3Key: string,
    description?: string,
    originalFileName?: string,
    presignedDownloadURL?: string // TODO DSy: do we want to bulk generate this in the caller?
};

export default function DocumentStoreFileDetail(props: DocumentStoreFileDetailProps) {
    const [displayFullScreen, setDisplayFullScreen] = useState(false)
    const [downloadURL, setDownloadURL] = useState<string | undefined>(undefined)
    const [blobURL, setBlobURL] = useState<string | undefined>(undefined)

    const isPDF = props.s3Key.toLowerCase().includes('.pdf');

    const [loading, error, errMsg, result] = useServiceHook(
        DocumentStoreService.generatePresignedDownloadURL,
        [props.documentStoreRecordId, props.s3Key],
        (props.presignedDownloadURL == undefined),
        [],
        undefined,
        []
    );

    useEffect(() => {
        // Once we have the presigned URL, save the file locally before it's viewed fullscreen.
        if (downloadURL) {
            let localURL: string | undefined;

            fetch(downloadURL)
                .then(response => response.blob())
                .then(blob => {
                    localURL = URL.createObjectURL(blob);
                    setBlobURL(localURL);
                })
                .catch(err => console.error('File preload failed:', err));

            return () => {
                if (localURL) {
                    URL.revokeObjectURL(localURL);
                }
            };
        }
    }, [downloadURL]);

    if (props.presignedDownloadURL != undefined && downloadURL == undefined) {
        setDownloadURL(props.presignedDownloadURL)
    }

    if (!loading && result && result['presigned_download_urls'] && result['presigned_download_urls'].length > 0 && downloadURL == undefined
        && props.presignedDownloadURL == undefined) {
        setDownloadURL(result['presigned_download_urls'][0]['presigned_download_url'])
    }

    const closeFullScreenModal = (event: any) => {
        event.preventDefault();
        setDisplayFullScreen(false);
    };

    const openFullScreenModal = (event: any) => {
        event.preventDefault();
        setDisplayFullScreen(true);
    };

    return (
        <>
            {loading && <LoadingSpinner />}

            {
                downloadURL &&
                <PanelItem
                    header={props.description || 'File'}
                    headerTextStyleCfg={{ bold: true }}
                    value={<a href='' onClick={openFullScreenModal}>View Document</a>}
                />
            }

            {
                downloadURL && displayFullScreen &&

                <InfoModalContainer stylesCfg={{ height: 'auto', maxHeight: '96%', width: 'auto', padding: '2vh 1vw' }}>
                    <div style={{ overflow: 'auto', width: '100%' }}>
                        {
                            isPDF &&
                            <object data={blobURL || downloadURL} width='1200' height='800'
                                data-testid='fileFullScreenPDF' />
                        }
                        {
                            !isPDF &&
                            <img src={blobURL || downloadURL} style={{ width: '100%', height: 'auto' }}
                                data-testid='fileFullScreenNonPDF' />
                        }
                        <Button label='Close' onClickFunc={closeFullScreenModal} />
                    </div>
                </InfoModalContainer>

            }
        </>
    )
}